import axios from "axios";

export const consultarCEP = async cep => {
    const cepNum = cep ? cep.match(/\d+/gi).join("") : {};
    if (cepNum.length != 8) return false;
    try {
        const { data } = await axios.get(`//viacep.com.br/ws/${cepNum}/json/`);
        if (data.erro) return false;
        return data;
    } catch (err) {
        return false;
    }
}

export const toDecimal = (item) => {
	let decimal = 0
	while (decimal == 0) {
		if (item.includes('.')){
			item = item.replace('.','')
		} else {
			decimal = 1
		}
	}
	return parseFloat(item.replace(',','.'))
}